import { StoreStackNavigator } from "./StoreStackNavigator";

export const StoreScreen = () => {
  return <StoreStackNavigator />;
};
